<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" data-testid="client-banner-address" @click="open">
            <span v-if="client.address !== null" style="border-bottom: 1px dotted gray">
                <span v-if="client.address.is_old_address === true" class="text-danger">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </span>
                <span v-else="" class="text-success">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </span>
                <span>{{ client.address.full_address }}</span>
            </span>
            <span v-else="" style="border-bottom: 1px dotted gray">
                <span class="text-danger"><i class="fa fa-home" aria-hidden="true"></i> Chybí adresa bydliště</span>
            </span>
        </span>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_col">
                <div class="row tooltip_header">
                    <div class="col-sm-2 text-left">
                        <button class="btn btn-sm btn-outline-secondary" data-testid="client-address-edit" @click="edit" v-if="editMode === false && client.address"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> upravit</button>
                        <button class="btn btn-sm btn-outline-secondary" data-testid="client-address-back" @click="view" v-else-if="editMode === true && client.address"><i class="fa fa-arrow-left" aria-hidden="true"></i> zpět</button>
                    </div>
                    <div class="col-sm-8" v-if="client.address === null && editMode === true">Nastavení adresy trvalého bydliště</div>
                    <div class="col-sm-8" v-else-if="editMode === true">Úprava adresy trvalého bydliště</div>
                    <div class="col-sm-8" v-else="">Adresa trvalého bydliště</div>
                    <div class="col-sm-2"></div>
                </div>

                <div class="row" v-if="editMode === true">

                    <div class="col-sm-12 tooltip_body text-left">
                        <form @submit.prevent="submitForm">
                            <div class="row justify-content-around">
                                <span>Česká</span>
                                <label class="switch switch-lg switch-text switch-primary">
                                    <input v-model="searchOutsideCzechia" type="checkbox" class="switch-input" id="searchInCzechia" data-testid="client-address-foreign-toggle">
                                    <span class="switch-label" data-on="" data-off=""></span>
                                    <span class="switch-handle"></span>
                                </label>
                                <span>zahraniční</span>
                            </div>
                            <template v-if="!searchOutsideCzechia">
                                <div class="row justify-content-center">
                                    <div class="form-group col-md-12">
                                        <multiselect v-model="selected"
                                                     :reset-after="true"
                                                     id="search"
                                                     data-testid="client-address-search-czech"
                                                     label="label"
                                                     track-by="code"
                                                     placeholder="vyhledat adresu"
                                                     open-direction="bottom"
                                                     :options="addresses"
                                                     :multiple="false"
                                                     :searchable="true"
                                                     :internal-search="false"
                                                     :close-on-select="true"
                                                     :options-limit="300"
                                                     :limit="3"
                                                     :max-height="600"
                                                     :show-no-results="false"
                                                     @search-change="getResult"
                                                     @select="openAddress"
                                                     :clear-on-select="true"
                                                     selectLabel="">
                                            <template slot="option" scope="props">
                                                <div class="option__desc">
                                                    <span class="option__title" :class="props.option.available === true ? 'available' : 'unavailable'">
                                                        <div class="row m-0 pb-1">
                                                            <div class="col-sm-6">{{ props.option.values.WHOLE_ADDRESS }}</div>
                                                        </div>
                                                        <div class="row m-0 font-sm">
                                                            <div class="col-sm-12">
                                                                <span>{{ props.option.values.DISTRICT }}</span>,&nbsp;
                                                                <span>{{ props.option.values.REGION }}</span>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </template>
                            <template v-else="">
                                <div class="row justify-content-center">
                                    <div class="form-group col-md-12">
                                        <multiselect v-model="selected"
                                                     :reset-after="true"
                                                     id="searchForeign"
                                                     data-testid="client-address-search-foreign"
                                                     label="label"
                                                     track-by="code"
                                                     placeholder="vyhledat adresu v cizině"
                                                     open-direction="bottom"
                                                     :options="foreignAddresses"
                                                     :multiple="false"
                                                     :searchable="true"
                                                     :internal-search="false"
                                                     :close-on-select="true"
                                                     :options-limit="300"
                                                     :limit="3"
                                                     :max-height="600"
                                                     :show-no-results="false"
                                                     @search-change="getForeignAddressResult"
                                                     @select="openForeignAddress"
                                                     :clear-on-select="true"
                                                     selectLabel="">
                                            <template slot="option" scope="props">
                                                <div class="option__desc">
                                                    <span class="option__title" :class="props.option.available === true ? 'available' : 'unavailable'">
                                                        <div class="row m-0 pb-1">
                                                            <div class="col-sm-6">{{ props.option.description }}</div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </template>

                            <div class="row justify-content-center">
                                <div class="form-group col-md-9">
                                    <label for="street">Ulice</label>
                                    <input v-model="addressForm.street" type="text" class="form-control" data-testid="client-address-street" aria-describedby="streetHelp" id="street" disabled="disabled">
                                    <small id="streetError" class="form-text text-danger" v-if="addressError.street">{{ addressError.street.message }}</small>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="houseNumber">Číslo</label>
                                    <input v-model="addressForm.house_number" type="text" class="form-control" data-testid="client-address-house-number" aria-describedby="houseNumberHelp" id="houseNumber" disabled="disabled">
                                    <small id="houseNumberError" class="form-text text-danger" v-if="addressError.housenumber">{{ addressError.housenumber.message }}</small>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="form-group col-md-4">
                                    <label for="zip_code">PSČ</label>
                                    <input v-model="addressForm.zip_code" type="text" class="form-control" data-testid="client-address-zip-code" aria-describedby="zip_codeHelp" id="zip_code" disabled="disabled">
                                    <small id="zipCodeError" class="form-text text-danger" v-if="addressError.zipcode">{{ addressError.zipcode.message }}</small>
                                </div>
                                <div class="form-group col-md-8">
                                    <label for="city">Město</label>
                                    <input v-model="addressForm.city" type="text" class="form-control" data-testid="client-address-city" aria-describedby="cityHelp" id="city" disabled="disabled">
                                    <small id="cityError" class="form-text text-danger" v-if="addressError.city">{{ addressError.city.message }}</small>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="form-group col-md-6">
                                    <label for="district">Okres</label>
                                    <input v-model="addressForm.district" type="text" class="form-control" data-testid="client-address-district" aria-describedby="districtHelp" id="district" disabled="disabled">
                                    <small id="districtError" class="form-text text-danger" v-if="addressError.district">{{ addressError.district.message }}</small>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="region">Kraj</label>
                                    <input v-model="addressForm.region" type="text" class="form-control" data-testid="client-address-region" aria-describedby="regionHelp" id="region" disabled="disabled">
                                    <small id="regionError" class="form-text text-danger" v-if="addressError.region">{{ addressError.region.message }}</small>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <span v-if="lastAddress">Předchozí adresa: {{ lastAddress }}</span>
                            </div>
                            <!--<div class="row justify-content-center">-->
                                <!--<div class="form-group col-md-12">-->
                                    <!--<label for="country">Země:</label>-->
                                    <!--<div class="input-group">-->
                                        <!--<select v-model="addressForm.country" class="form-control" aria-describedby="countryHelp" id="country">-->
                                            <!--<option v-for="row in countries" v-bind:value="row.id">{{ row.name }}</option>-->
                                        <!--</select>-->
                                        <!--<small id="countryError" class="form-text text-danger" v-if="addressError.country">{{ addressError.country.message }}</small>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <div class="row justify-content-center">
                                <div class="form-group col-md-12 text-center">
                                    <button v-if="addressPending === false" data-testid="client-address-save" type="submit" class="btn btn-primary">Uložit adresu</button>
                                    <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row" v-else-if="client.address">
                    <table class="table table_labeled table-bordered" data-testid="client-address-table">
                        <tr class="row m-0">
                            <td class="col-sm-12"><span class="td_label">ulice a čp.</span>{{ client.address.street | neverEmpty }}</td>
                            <!--<td class="col-sm-4"><span class="td_label">čp / čo</span>{{ client.address.house_number | neverEmpty }}</td>-->
                        </tr>
                        <tr class="row m-0">
                            <td class="col-sm-4"><span class="td_label">PSČ</span>{{ client.address.zip_code | neverEmpty }}</td>
                            <td class="col-sm-8"><span class="td_label">obec</span>{{ client.address.city | neverEmpty }}</td>
                        </tr>
                        <tr class="row m-0">
                            <td colspan="2" class="col-sm-12"><span class="td_label">stát</span>{{ (client.address.country ? client.address.country.name : '') | neverEmpty }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'
  import _ from 'lodash'

  export default {
    data () {
      return {
        editMode: false,
        isOpen: false,
        countries: null,
        countriesPending: true,
        countriesError: false,
        hadAddress: false,
        addressPending: false,
        addressDone: false,
        addressError: false,
        lastAddressIsOld: false,
        addressForm: {
          country: 1,
          street: '',
          house_number: '',
          city: '',
          zip_code: '',
          district: '',
          region: '',
          full_maps_data: null
        },
        lastAddress: false,
        selected: '',
        addresses: [],
        foreignAddresses: [],
        foreignAddressDetail: {},
        toSearchText: '',
        toSearchForeignText: '',
        searchOutsideCzechia: false,
        foreignAddressDetailDone: false
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      init () {
        this.addressError = false
      },
      open () {
        this.init()
        if (this.client.address) {
          this.hadAddress = true
          this.editMode = false
          // this.addressForm = JSON.parse(JSON.stringify(this.client.address, this.replacer))
          // this.addressForm.country = this.addressForm.country ? this.addressForm.country.id : null
          this.addressForm.id = this.client.address.id
          this.lastAddress = this.client.address.full_address
          this.lastAddressIsOld = this.client.address.is_old_address === true
        } else {
          this.hadAddress = false
          this.addressForm = { country: 1 }
          this.editMode = true
        }
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      },
      edit () {
        this.editMode = true
      },
      view () {
        this.editMode = false
      },
      submitForm () {
        if (this.hadAddress && this.lastAddressIsOld === false) {
          this.putAddress(this.addressForm)
        } else {
          this.postAddress(this.addressForm, this.client.id)
        }
      },
      getResult (text) {
        this.toSearchText = text
      },
      getForeignAddressResult (text) {
        this.toSearchForeignText = text
      },
      openAddress (value) {
        this.addressForm.street = value.values.STREET
        this.addressForm.house_number = value.values.NUMBER
        this.addressForm.city = value.values.CITY
        this.addressForm.zip_code = value.values.ZIP
        this.addressForm.district = value.values.DISTRICT
        this.addressForm.region = value.values.REGION
        this.addressForm.full_maps_data = null
      },
      openForeignAddress (value) {
        this.getForeignAddressDetail(value.place_id)
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          if (this.countries === null) {
            this.getCountries()
          }
        } else {
          //
        }
      },
      addressDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.addressDone = false
          this.close()
        }
      },
      searchOutsideCzechia (val) {
        if (val === true) {
          this.addressForm.country = null
        } else {
          this.addressForm.country = 1
        }
      },
      toSearchText: _.debounce(function (text) {
        this.searchAddresses(text)
      }, 1500),
      toSearchForeignText: _.debounce(function (text) {
        this.searchForeignAddresses(text)
      }, 1500),
      foreignAddressDetailDone (val) {
        if (val === true) {
          this.addressForm.country = null
          this.addressForm.street = ''
          this.addressForm.house_number = ''
          this.addressForm.city = ''
          this.addressForm.zip_code = ''
          this.addressForm.district = ''
          this.addressForm.region = ''
          this.addressForm.full_maps_data = null

          let city = []
          for (var i = 0, len = this.foreignAddressDetail.address_components.length; i < len; i++) {
            let addressPart = this.foreignAddressDetail.address_components[i]
            if (addressPart.types.includes('street_number')) {
              this.addressForm.house_number = addressPart.long_name
            }
            if (addressPart.types.includes('postal_code')) {
              this.addressForm.zip_code = addressPart.long_name
            }
            if (addressPart.types.includes('locality')) {
              city[0] = addressPart.long_name
            }
            if (addressPart.types.includes('sublocality')) {
              city[1] = addressPart.long_name
            }
            if (addressPart.types.includes('route')) {
              this.addressForm.street = addressPart.long_name
            }
            if (addressPart.types.includes('administrative_area_level_1')) {
              this.addressForm.region = addressPart.long_name
            }
            if (addressPart.types.includes('administrative_area_level_2')) {
              this.addressForm.district = addressPart.long_name
            }
          }
          city = city.filter(function (el) {
            return el != null
          })
          this.addressForm.city = city.join(', ')
          this.addressForm.full_maps_data = this.foreignAddressDetail
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge_large {
        font-size: xx-large;
    }
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientAddress.vue?b7be9136